
/*
  Created
    by: Upendram Reddy Tanuja
    on: 21-Aug-2019 07:30 PM
    purpose: Password Manager component
    comments:  Password Manager details
*/
import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { PasswordManagerService } from 'src/app/services/password-manager/password-manager.service';


@Component({
  selector: 'app-password-manager',
  templateUrl: './password-manager.component.html',
  styleUrls: ['./password-manager.component.scss']
})
export class PasswordManagerComponent implements OnInit {

  //variable for form
  password_manager_form: UntypedFormGroup;


  route_subscription: Subscription;

  init() {
    this.password_manager_form = new UntypedFormGroup({
      password: new UntypedFormControl('', [Validators.required]),
      re_enter_password: new UntypedFormControl('', Validators.required),


    });

  }



  constructor(
    private password_manager_service: PasswordManagerService,
    private router: Router,
    private activated_route: ActivatedRoute,


  ) { }
  // :encrypted_user_id/:time_stamp/:expire_hours',
  user_id;
  ngOnInit() {
    this.init();
    this.user_id = this.activated_route.snapshot.params.user_id;
    this.password_manager_service.getPasswordStatus(this.user_id).subscribe(res => {

      if (res["status"] == true) {
        this.getPasswordManager();
      }
      else
        if (res["status"] == false) {
          this.router.navigate(['/link-exipred']);
        }
    });

    //subscribe to route changes. if the user selects another changepassword, listen to route changes and call the API only if user_id is present in the URL and user_id in the URL is not same as the one that is already present

    // this.route_subscription = this.routes_service.routeListener().subscribe((val) => {
    //   if (!this.password_manager || (this.password_manager && this.password_manager.user_id != val['user_id'])) {
    //     this.init();
    //     this.getPasswordManager()
    //   }
    // })
  }

  getPasswordManager() {


  }


  save() {

    this.password_manager_service.saveDetails(this.user_id, this.password_manager_form.value).subscribe(res => {

      if (res["status"] == true) {
        this.router.navigate(['/login']);
      }
      else
        if (res["status"] == false) {
          this.router.navigate(['/link-exipred']);
        }
    })

  }
cancel(){

}

  // ngOnDestroy() {
  //   this.route_subscription.unsubscribe();
  // }

}

